import { format, isSameDay, isSameMonth, isSameYear } from 'date-fns'
import { de, enGB as en } from 'date-fns/locale'
import { Locale } from '../generated/graphcms'

export default function formatDateRange(
  startDate: Date,
  endDate: Date,
  locale: Locale = Locale.En
): string {
  const dateLocale = { de, en }

  const options = { locale: dateLocale[locale] }
  const formatOpt = (_date: Date, _format: string) => format(_date, _format, options)

  if (
    isSameDay(startDate, endDate) &&
    isSameMonth(startDate, endDate) &&
    isSameYear(startDate, endDate)
  ) {
    return `${formatOpt(startDate, 'MMM d yyyy')}`
  }

  if (isSameMonth(startDate, endDate) && isSameYear(startDate, endDate)) {
    return `${formatOpt(startDate, 'MMM d')} - ${formatOpt(endDate, 'd yyyy')}`
  }

  if (isSameYear(startDate, endDate)) {
    return `${formatOpt(startDate, 'MMM d')} - ${formatOpt(endDate, 'MMM d yyyy')}`
  }

  return `${formatOpt(startDate, 'MMM d yyyy')} - ${formatOpt(endDate, 'MMM d yyyy')}`
}
